import styled from "styled-components";

const SimplebarItems = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export default SimplebarItems